var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-home"},[_c('img',{staticClass:"card-home__icon",attrs:{"src":_vm.card.icon,"width":"35%"}}),_c('span',{staticClass:"card-home__title mt-2 white--text",domProps:{"innerHTML":_vm._s(_vm.card.htmlText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }